import { AnimatePresence, motion } from "motion/react";

interface AnimatedTextProps {
  text: string;
  className?: string;
}

export const AnimatedText = ({ text, className }: AnimatedTextProps) => {
  return (
    <div className={className}>
      <AnimatePresence mode="wait">
        <motion.div
          key={text}
          initial="initial"
          animate="animate"
          exit="exit"
          className="inline-flex flex-wrap items-center gap-x-1.5"
          style={{
            transform: "translateZ(0)",
            backfaceVisibility: "hidden",
          }}
        >
          <motion.span
            key={`${text}`}
            variants={{
              initial: {
                opacity: 0,
              },
              animate: {
                opacity: 1,
                transition: {
                  duration: 0.1,
                  delay: 0.3,
                },
              },
            }}
            className="inline-block font-heading text-[16px] font-bold text-foreground"
          >
            {text}
          </motion.span>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
